var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgP2P = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 25,
    viewBox: "0 0 122 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.627403 0C0.372703 0 0.166504 0.206199 0.166504 0.460899V14.2866C0.166504 14.5412 0.372703 14.7475 0.627403 14.7475H36.5744C36.829 14.7475 37.0352 14.5412 37.0352 14.2866V0.460899C37.0352 0.206199 36.829 0 36.5744 0H0.627403ZM32.1962 10.1389C32.3234 10.1389 32.4266 10.0357 32.4266 9.9085V4.839C32.4266 4.7118 32.3234 4.6086 32.1962 4.6086H5.0055C4.8783 4.6086 4.7751 4.7118 4.7751 4.839V9.9085C4.7751 10.0357 4.8783 10.1389 5.0055 10.1389H32.1962Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7751 20.7389C4.7751 20.4843 4.56891 20.2781 4.31421 20.2781H0.627403C0.372703 20.2781 0.166504 20.4843 0.166504 20.7389V24.4258C0.166504 24.6804 0.372703 24.8867 0.627403 24.8867H4.31421C4.56891 24.8867 4.7751 24.6804 4.7751 24.4258V20.7389Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5728 20.7389C89.5728 20.4843 89.3668 20.2781 89.1118 20.2781H85.4249C85.1709 20.2781 84.9648 20.4843 84.9648 20.7389V24.4258C84.9648 24.6804 85.1709 24.8867 85.4249 24.8867H89.1118C89.3668 24.8867 89.5728 24.6804 89.5728 24.4258V20.7389Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5654 20.7389C42.5654 20.4843 42.7717 20.2781 43.0263 20.2781H78.973C79.228 20.2781 79.434 20.4843 79.434 20.7389V24.4258C79.434 24.6804 79.228 24.8867 78.973 24.8867H43.0263C42.7717 24.8867 42.5654 24.6804 42.5654 24.4258V20.7389Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9648 0.460899C84.9648 0.206199 85.1709 0 85.4249 0H121.372C121.627 0 121.833 0.206199 121.833 0.460899V14.2866C121.833 14.5412 121.627 14.7475 121.372 14.7475H85.4249C85.1709 14.7475 84.9648 14.5412 84.9648 14.2866V0.460899ZM116.994 4.6086C117.121 4.6086 117.225 4.7118 117.225 4.839V9.9085C117.225 10.0357 117.121 10.1389 116.994 10.1389H89.8038C89.6758 10.1389 89.5728 10.0357 89.5728 9.9085V4.839C89.5728 4.7118 89.6758 4.6086 89.8038 4.6086H116.994Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0263 0C42.7717 0 42.5654 0.206199 42.5654 0.460899V4.1477C42.5654 4.4024 42.7717 4.6086 43.0263 4.6086H74.595C74.722 4.6086 74.826 4.7118 74.826 4.839V9.9085C74.826 10.0357 74.722 10.1389 74.595 10.1389H43.0263C42.7717 10.1389 42.5654 10.3451 42.5654 10.5998V14.2866C42.5654 14.5412 42.7717 14.7475 43.0263 14.7475H78.973C79.228 14.7475 79.434 14.5412 79.434 14.2866V0.460899C79.434 0.206199 79.228 0 78.973 0H43.0263Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgP2P);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/p2p.d1924e0814039346602db9d7a5080688.svg";